import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import Toggle from '../form/Toggle'
import SocialSettingsModal from './SocialSettingsModal'
import { ReactComponent as ShieldIcon } from '../../../assets/images/common/icons/shield-check-mark.svg'
import { ReactComponent as QuestionIcon } from '../../../assets/images/common/icons/question-mark-circle.svg'

import classes from './ChildSocialFeatureSettings.module.scss'

const ChildSocialFeatureSettings = ({
  allowPostingContent,
  allowPostingComments,
  onChangePostingContent,
  onChangePostingComments,
  stacked,
}) => {
  const { t } = useTranslation()
  const [showHelpModal, setShowHelpModal] = useState(false)

  const columnClass = stacked ? 'col-12' : 'col-12 col-md-6'

  return (
    <div className={classes.toggleWrapper}>
      <div className='d-flex align-items-center mb-5'>
        <ShieldIcon className={classes.shieldIcon} aria-hidden='true' />
        <h4 className={classNames(classes.title, 'font-weight-bold mb-0 mx-2')}>{t('common.childSocialFeatureSettings.title')}</h4>
        <button
          type='button'
          className={classes.helpButton}
          onClick={() => setShowHelpModal(true)}
          aria-label={t('common.childSocialFeatureSettings.helpAriaLabel')}
        >
          <QuestionIcon className={classes.helpIcon} aria-hidden='true' />
        </button>
      </div>

      <div className='row'>
        <div className={classNames(columnClass, 'mb-4')}>
          <div className='d-flex align-items-start'>
            <Toggle
              size='small'
              id='allowPostingContent'
              checked={allowPostingContent}
              onChange={e => onChangePostingContent(e.target.checked)}
            />
            <label htmlFor='allowPostingContent' className={classNames(classes.toggleTitle, 'font-weight-bold mb-0 ml-3')}>
              {t('common.childSocialFeatureSettings.allowContentLabel')}
            </label>
          </div>
          <p className={classNames(classes.toggleDescription, 'mt-3')}>
            {t('common.childSocialFeatureSettings.allowContentDescription')}
          </p>
        </div>

        <div className={classNames(columnClass, 'mb-4')}>
          <div className='d-flex align-items-start'>
            <Toggle
              size='small'
              id='allowPostingComments'
              checked={allowPostingComments}
              onChange={e => onChangePostingComments(e.target.checked)}
            />
            <label htmlFor='allowPostingComments' className={classNames(classes.toggleTitle, 'font-weight-bold mb-0 ml-3')}>
              {t('common.childSocialFeatureSettings.allowCommentsLabel')}
            </label>
          </div>
          <p className={classNames(classes.toggleDescription, 'mt-3')}>
            {t('common.childSocialFeatureSettings.allowCommentsDescription')}
          </p>
        </div>
      </div>

      <SocialSettingsModal showModal={showHelpModal} closeModal={() => setShowHelpModal(false)} />
    </div>
  )
}

ChildSocialFeatureSettings.propTypes = {
  allowPostingContent: PropTypes.bool.isRequired,
  allowPostingComments: PropTypes.bool.isRequired,
  onChangePostingContent: PropTypes.func.isRequired,
  onChangePostingComments: PropTypes.func.isRequired,
  stacked: PropTypes.bool,
}

export default ChildSocialFeatureSettings
